import { Card, Descriptions, Input, Button } from "antd";
import { MutationResult, QueryResult } from "react-query";
import { IPendingAdminUnlockUser } from "../hooks/useGetPendingAdminUnlockUsers";
import { IResponse } from "../../../../interfaces/response";

interface IRequestDetailsTabProps {
  user: IPendingAdminUnlockUser;
  approvalComment: string;
  onCommentChange: (comment: string) => void;
  actionType: "approve" | "reject" | null;
  approveResult: MutationResult<IResponse<any>, unknown>;
  rejectResult: MutationResult<void, any>;
  onApprove: () => void;
  onDecline: () => void;
}

export default function RequestDetailsTab({
  user,
  approvalComment,
  onCommentChange,
  actionType,
  approveResult,
  rejectResult,
  onApprove,
  onDecline,
}: IRequestDetailsTabProps) {
  return (
    <div className="space-y-6">
      <Card title="User Information" className="shadow-sm">
        <Descriptions column={2}>
          <Descriptions.Item label="Name">
            {user.lockedUserName}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {user.lockedUserMail}
          </Descriptions.Item>
          <Descriptions.Item label="Workflow Code">
            {user.workflowCode}
          </Descriptions.Item>
          <Descriptions.Item label="Reference">
            {user.transactionReferenceNumber}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <br />
      <Card title="Lock / Unlock Reasons" className="shadow-sm">
        <Descriptions column={1}>
          <Descriptions.Item label="Lock Reason">
            {user.lockReason}
          </Descriptions.Item>
          {user.additionalLockDescription && (
            <Descriptions.Item label="Additional Lock Info">
              {user.additionalLockDescription}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Requested Unlock Reason">
            {user.unlockReason}
          </Descriptions.Item>
          {user.additionalUnlockDescription && (
            <Descriptions.Item label="Additional Unlock Info">
              {user.additionalUnlockDescription}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
      <br />
      <div>
        <label className="label-txt">Comment</label>
        <Input.TextArea
          rows={4}
          placeholder="Add a comment..."
          value={approvalComment}
          onChange={(e) => onCommentChange(e.target.value)}
          style={{ resize: "vertical" }}
        />
      </div>
      <br />
      <div className="d-flex justify-content-end" style={{ gap: "8px" }}>
        <Button
          size="large"
          disabled={rejectResult.isLoading}
          loading={actionType === "reject" && rejectResult.isLoading}
          onClick={onDecline}
        >
          Decline
        </Button>
        <Button
          type="primary"
          size="large"
          disabled={approveResult.isLoading}
          loading={actionType === "approve" && approveResult.isLoading}
          onClick={onApprove}
        >
          Approve
        </Button>
      </div>
    </div>
  );
}
